import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1665760670979-708eb9626d73?q=80&w=1920&auto=format&fit=crop" 
          alt="Modern aesthetic clinic background" 
          className="w-full h-full object-cover opacity-80"
        />
        <div
          className="absolute inset-0 bg-gradient-to-b from-cream/30 via-cream/10 to-cream"
          style={{
            backgroundColor: "#4f5a33"
          }}></div>
      </div>
      <div className="container-custom relative z-10 text-center max-w-4xl mx-auto px-4">
        <motion.span 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="block text-white font-medium tracking-[0.2em] uppercase mb-6 text-sm md:text-base"
        >
          mario huerta roman
        </motion.span>
        
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold mb-6 leading-tight"
          style={{ color: "#fefffc" }}
        >
          Experience Relief Through <br/> Expert Chiropractic Care
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-lg md:text-xl mb-10 max-w-2xl mx-auto font-light leading-relaxed"
          style={{ color: "#ffffff" }}
        >
          Restore your body’s natural balance with personalized chiropractic care focused on pain relief, mobility, posture correction, and long-term wellness.
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="flex flex-col sm:flex-row justify-center gap-4"
        >
          <a
            href="#contact"
            className="bg-forest text-cream px-8 py-4 rounded-sm font-medium hover:bg-forest-light transition-all duration-300 uppercase tracking-wide text-sm shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            style={{
              backgroundColor: "#4f5a33"
            }}>
            Book Appointment
          </a>
          <a
            href="#services"
            className="bg-transparent border border-forest text-forest px-8 py-4 rounded-sm font-medium hover:bg-forest hover:text-cream transition-all duration-300 uppercase tracking-wide text-sm"
            style={{
              backgroundColor: "rgb(79, 90, 51)",
              color: "#ffffff"
            }}>
            Explore Services
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
